{
  "PDF preview": "Перегляд PDF",
  "Zoom out": "Зменшити",
  "Zoom in": "Збільшити",
  "Fit width": "За шириною",
  "Choose valid collection columns without duplicates.": "Виберіть допустимі стовпці списку без повторень.",
  "Settings": "Налаштування",
  "Main menu": "Головне меню",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": ", а не",
  ". Changing construction class requires a different identity.": ". Зміна типу конструкції потребує іншого ідентифікатора.",
  ". It is shown only once.": ". Показано лише один раз.",
  ". Where-used follows the actual structure—not the numbering path.": ". Використання визначається фактичною структурою, а не шляхом нумерації.",
  "? The history remains.": "? Історія зберігається.",
  "? The original part remains in the registry.": "? Оригінальна деталь залишається в реєстрі.",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "PIN має містити проєкт, версію виробу та щонайменше один вузол ідентичності; глибина — до 32.",
  "A change is awaiting confirmation": "Зміна очікує підтвердження",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "Для зміни типу контрольованої конструкції створіть іншу деталь, а не перейменовуйте цю.",
  "A new link will replace the previous invitation link for": "Нове посилання замінить попереднє запрошення для",
  "A part cannot replace itself.": "Деталь не може замінювати сама себе.",
  "A piece part cannot have a configuration.": "Деталь не може мати конфігурацію.",
  "A piece part cannot have controlled children.": "Деталь не може містити контрольовані компоненти.",
  "A piece part cannot retain controlled children.": "Деталь не може зберігати контрольовані компоненти.",
  "A qualified reference must select a released revision.": "Уточнене посилання має вказувати випущену ревізію.",
  "A verified Google email is required.": "Потрібна підтверджена електронна адреса Google.",
  "ALPHA": "ALPHA",
  "About {value0}": "Про {value0}",
  "Accept company invitation": "Прийняти запрошення до компанії",
  "Account": "Обліковий запис",
  "Account and company settings": "Налаштування облікового запису й компанії",
  "Active": "Активне",
  "Active assembly": "Поточна збірка",
  "Add alias": "Додати зовнішній номер",
  "Add code": "Додати код",
  "Add directional replacement": "Додати напрямлену заміну",
  "Add part": "Додати деталь",
  "Add replacement": "Додати заміну",
  "Add to {value0}": "Додати до {value0}",
  "Adding…": "Додавання…",
  "Alias notes": "Примітки до зовнішнього номера",
  "Alias organization": "Організація зовнішнього номера",
  "Alias type": "Тип зовнішнього номера",
  "All alias types": "Усі типи зовнішніх номерів",
  "All companies": "Усі компанії",
  "All selected child revisions must be released.": "Усі вибрані ревізії компонентів мають бути випущені.",
  "All states": "Усі стани",
  "All types": "Усі типи",
  "Aluminium": "Алюміній",
  "An assembly needs at least one controlled child before release.": "Перед випуском збірка повинна містити щонайменше один контрольований компонент.",
  "An example drawing change tightens a tolerance.": "У прикладі зміна креслення звужує допуск.",
  "An external alias cannot impersonate another canonical part number.": "Зовнішній номер не може збігатися з канонічним номером іншої деталі.",
  "An identifier or historical alias already occupies the requested number.": "Запитаний номер уже зайнятий ідентифікатором або історичним перенаправленням.",
  "An independently orderable configured product needs its own assembly P/N.": "Конфігурований виріб, що замовляється окремо, потребує власного номера збірки.",
  "An invitation is already pending. Replace its link instead.": "Запрошення вже очікує відповіді. Замініть його посилання.",
  "An occurrence cannot be moved to another owner by editing it.": "Не можна перенести використання деталі до іншого власника редагуванням.",
  "Another change was being saved. Retry this same request.": "Зберігалася інша зміна. Повторіть цей самий запит.",
  "Another owner must accept membership before removing the last owner.": "Перш ніж видалити останнього власника, інший власник має прийняти запрошення.",
  "Another project": "Інший проєкт",
  "Apply filters": "Застосувати фільтри",
  "Arm": "Рука",
  "Arm assembly": "Збірка руки",
  "As authored": "Як задано",
  "Ask a company owner to register a new code.": "Попросіть власника компанії зареєструвати новий код.",
  "Assembly": "Збірка",
  "Assembly configurations": "Конфігурації збірки",
  "Assignment correction": "Виправлення призначення",
  "Back to blueprint": "До креслення",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "До появи контрольованих залежностей призначення можна виправити із записом в аудиті. Старий номер не перенаправляється.",
  "Best match": "Найкращий збіг",
  "Bonded": "Клеєне",
  "Bonded assembly": "Клеєна збірка",
  "Bonded grip": "Клеєний захват",
  "Both leaders point to the same P/N.": "Обидві виноски вказують на той самий номер.",
  "CF": "CF",
  "Cancel": "Скасувати",
  "Cancel {value0} edit": "Скасувати редагування {value0}",
  "Carbon fibre": "Вуглепластик",
  "Change {value0}'s role": "Змінити роль {value0}",
  "Check result": "Перевірити результат",
  "Choose Active, Obsolete or Retired.": "Виберіть: активна, застаріла або виведена з використання.",
  "Choose Owner, Editor or Viewer.": "Виберіть власника, редактора або читача.",
  "Choose P, A, W, G or R.": "Виберіть P, A, W, G або R.",
  "Choose a company": "Виберіть компанію",
  "Choose a measurement unit preference.": "Виберіть систему одиниць вимірювання.",
  "Choose a part and exact revision from this company.": "Виберіть деталь і точну ревізію з цієї компанії.",
  "Choose a product version from the default project.": "Виберіть версію виробу з типового проєкту.",
  "Choose a standard position or register its code in this company.": "Виберіть стандартне положення або зареєструйте код у цій компанії.",
  "Choose a supplier, manufacturer or customer alias.": "Виберіть зовнішній номер постачальника, виробника або замовника.",
  "Choose a supported interface language.": "Виберіть підтримувану мову інтерфейсу.",
  "Choose a supported regional format.": "Виберіть підтримуваний регіональний формат.",
  "Choose a table density.": "Виберіть щільність таблиці.",
  "Choose a valid alias type.": "Виберіть коректний тип зовнішнього номера.",
  "Choose a valid part state.": "Виберіть коректний стан деталі.",
  "Choose a valid part type.": "Виберіть коректний тип деталі.",
  "Choose a valid results page and page size.": "Виберіть коректну сторінку результатів та її розмір.",
  "Choose a valid search order.": "Виберіть коректний порядок пошуку.",
  "Choose a valid time zone.": "Виберіть коректний часовий пояс.",
  "Choose an assembly parent in the selected product version.": "Виберіть батьківську збірку в цій версії виробу.",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "Виберіть батьківську збірку в цій версії виробу поза деревом нащадків цієї деталі.",
  "Choose an editable assembly and an exact part revision.": "Виберіть доступну для редагування збірку та точну ревізію деталі.",
  "Choose each time": "Вибирати щоразу",
  "Choose exactly one structure owner.": "Виберіть рівно одного власника структури.",
  "Choose its revision and quantity to add it to this assembly.": "Виберіть ревізію та кількість для додавання до цієї збірки.",
  "Choose one structure owner.": "Виберіть одного власника структури.",
  "Choose the default company first.": "Спочатку виберіть типову компанію.",
  "Choose the part that can replace this one.": "Виберіть деталь, яка може замінити цю.",
  "Class": "Клас",
  "Clear filters": "Очистити фільтри",
  "Close": "Закрити",
  "Close reuse parts": "Закрити повторне використання деталей",
  "Close {value0}": "Закрити {value0}",
  "Code": "Код",
  "Comfortable": "Зручна",
  "Compact": "Компактна",
  "Companies": "Компанії",
  "Company": "Компанія",
  "Company code": "Код компанії",
  "Company name": "Назва компанії",
  "Company not found.": "Компанію не знайдено.",
  "Company parts": "Деталі компанії",
  "Company settings": "Налаштування компанії",
  "Company-wide role": "Роль у компанії",
  "Configuration": "Конфігурація",
  "Configuration name": "Назва конфігурації",
  "Configurations": "Конфігурації",
  "Configurations apply to assemblies, not piece parts.": "Конфігурації застосовуються до збірок, а не до деталей.",
  "Construction classes": "Типи конструкції",
  "Copy a revision of this part.": "Скопіювати ревізію цієї деталі.",
  "Correct engineering identity": "Виправити інженерну ідентичність",
  "Corrected text": "Виправлений текст",
  "Correction & replacement": "Виправлення й заміна",
  "Correction reason": "Причина виправлення",
  "Cover": "Кришка",
  "Cover numbered beneath it": "Кришка з номером під цією збіркою",
  "Cover revisions": "Ревізії кришки",
  "Cover · 1 each · forearm": "Кришка · 1 шт. · передпліччя",
  "Create company": "Створити компанію",
  "Create configuration": "Створити конфігурацію",
  "Create invitation": "Створити запрошення",
  "Create project": "Створити проєкт",
  "Create variant": "Створити варіант",
  "Create version": "Створити версію",
  "Current structure": "Поточна структура",
  "Default quantity unit": "Типова одиниця кількості",
  "Default workspace": "Типовий робочий простір",
  "Description": "Опис",
  "Details": "Відомості",
  "Different identity": "Інша ідентичність",
  "Directional replacements": "Напрямлені заміни",
  "Draft": "Чернетка",
  "Drawing unavailable. Part-number examples remain interactive.": "Креслення недоступне. Приклади номерів залишаються інтерактивними.",
  "ER": "ER",
  "Edit company": "Редагувати компанію",
  "Edit configuration": "Редагувати конфігурацію",
  "Edit details": "Редагувати відомості",
  "Edit part details": "Редагувати відомості деталі",
  "Edit part use": "Редагувати використання деталі",
  "Edit product version": "Редагувати версію виробу",
  "Edit project": "Редагувати проєкт",
  "Editor": "Редактор",
  "Engineering": "Інженерія",
  "Engineering Registry": "Інженерний реєстр",
  "Enter a canonical PIN.": "Введіть канонічний PIN.",
  "Enter a position code.": "Введіть код положення.",
  "Enter a positive quantity and a unit.": "Введіть додатну кількість та одиницю.",
  "Enter a valid email address.": "Введіть дійсну адресу.",
  "Enter a variant code.": "Введіть код варіанта.",
  "Exact child revision": "Точна ревізія компонента",
  "Exact children in this baseline": "Точні компоненти цього базового складу",
  "Existing codes…": "Наявні коди…",
  "Existing hand, used in V": "Наявна кисть, використана у V",
  "Existing part": "Наявна деталь",
  "Explain": "Пояснити",
  "External aliases": "Зовнішні номери",
  "External part number": "Зовнішній номер деталі",
  "Filters": "Фільтри",
  "Find an existing part": "Знайти наявну деталь",
  "Find parts": "Знайти деталі",
  "Find {value0}": "Знайти {value0}",
  "For an unrelated part, leave Related part empty to allocate a new number.": "Для непов’язаної деталі залиште поле пов’язаної деталі порожнім, щоб отримати новий номер.",
  "Forearm cover": "Кришка передпліччя",
  "Front view · left/right is the robot’s own left/right": "Вигляд спереду · сторони відносно робота",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "Вигляд спереду. Права кисть робота ліворуч на кресленні, ліва — праворуч.",
  "Google account email": "Електронна адреса Google",
  "Google could not verify this sign-in. Try again.": "Google не підтвердив вхід. Спробуйте знову.",
  "Google sign-in could not load. Check your connection and try again.": "Не вдалося завантажити вхід Google. Перевірте з’єднання та спробуйте знову.",
  "Google sign-in is not configured.": "Вхід Google не налаштовано.",
  "Hand identities": "Ідентичності кистей",
  "Head casing": "Корпус голови",
  "Hide": "Приховати",
  "Historical rename": "Історичне перейменування",
  "History": "Історія",
  "Hole Ø6 mm · tolerance ±": "Отвір Ø6 mm · допуск ±",
  "Identity family": "Сімейство ідентичностей",
  "Identity history examples": "Приклади історії ідентичності",
  "Illustrative example · not your registry": "Ілюстративний приклад · не ваш реєстр",
  "Imperial": "Імперські",
  "Interactive robot part numbers": "Інтерактивні номери деталей робота",
  "Invitation link": "Посилання запрошення",
  "Invitation not found.": "Запрошення не знайдено.",
  "Invite person": "Запросити людину",
  "Issue part number": "Видати номер деталі",
  "Issue variant": "Видати варіант",
  "Issuing the cover beneath it appends": "Номер кришки під цією збіркою доповнюється",
  "It does not tell you where it is used now.": "Це не визначає поточне місце використання.",
  "Keep the part number and name columns; each column may appear only once.": "Залиште стовпці номера й назви; кожен стовпець має бути лише один раз.",
  "Knee pin ×2": "Колінний штифт ×2",
  "Language": "Мова",
  "Left / right": "Ліва / права",
  "Left hand": "Ліва кисть",
  "Left hand · 1 each · wrist": "Ліва кисть · 1 шт. · зап’ясток",
  "Loading…": "Завантаження…",
  "Main navigation": "Головна навігація",
  "Material": "Матеріал",
  "Meaning": "Значення",
  "Measurement units": "Одиниці вимірювання",
  "Members": "Учасники",
  "Metric": "Метричні",
  "Move {column} down": "Перемістити {column} нижче",
  "Move {column} up": "Перемістити {column} вище",
  "Name": "Назва",
  "Navigation": "Навігація",
  "Neither family membership nor a variant code promises interchangeability.": "Належність до сімейства й код варіанта не гарантують взаємозамінності.",
  "New assembly": "Нова збірка",
  "New camera in V2": "Нова камера у V2",
  "New camera, first numbered in V2": "Нова камера, вперше пронумерована у V2",
  "New codes are registered by a company owner.": "Нові коди реєструє власник компанії.",
  "New company": "Нова компанія",
  "New configuration": "Нова конфігурація",
  "New part": "Нова деталь",
  "New product version": "Нова версія виробу",
  "New project": "Новий проєкт",
  "New revision": "Нова ревізія",
  "New version": "Нова версія",
  "No choices available.": "Немає доступних варіантів.",
  "No parts yet.": "Деталей ще немає.",
  "No selected occurrences.": "Використання деталей не вибрано.",
  "None": "Немає",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "Ще не підтверджено. Повторіть збережену зміну, щоб безпечно визначити результат.",
  "Not found.": "Не знайдено.",
  "Notes": "Примітки",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "Нумерація під збіркою не додає кришку до її структури. Додавання виконується окремо; повторне використання зберігає цей номер.",
  "Numbering concept": "Поняття нумерації",
  "Numbering path": "Шлях нумерації",
  "Obsolete": "Застарілий",
  "Old text": "Старий текст",
  "Only !REV changes.": "Змінюється лише !REV.",
  "Only company owners can manage membership.": "Лише власники компанії можуть керувати учасниками.",
  "Only the configured administrator can create companies.": "Лише призначений адміністратор може створювати компанії.",
  "Open PIN": "Відкрити PIN",
  "Open navigation": "Відкрити навігацію",
  "Open project explorer": "Відкрити дерево проєктів",
  "Organization": "Організація",
  "Original identity": "Початкова ідентичність",
  "Overview": "Огляд",
  "Owner": "Власник",
  "P/N prefix": "Префікс номера",
  "P/N preview": "Попередній номер",
  "Page not found": "Сторінку не знайдено",
  "Part": "Деталь",
  "Part name": "Назва деталі",
  "Part number": "Номер деталі",
  "Part number preview": "Попередній перегляд номера деталі",
  "Part number ↑": "Номер деталі ↑",
  "Part number ↓": "Номер деталі ↓",
  "Part number, name, material or alias": "Номер, назва, матеріал або зовнішній номер",
  "Part numbering guide": "Довідник нумерації деталей",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "Префікси деталей змінюються разом; контрольовані історичні номери зберігають перенаправлення.",
  "Part record": "Картка деталі",
  "Part section": "Розділ деталі",
  "Part type": "Тип деталі",
  "Parts": "Деталі",
  "Parts first numbered in this product version.": "Деталі, вперше пронумеровані в цій версії виробу.",
  "Per page": "На сторінці",
  "Personal preferences": "Особисті налаштування",
  "Piece": "Деталь",
  "Piece part": "Окрема деталь",
  "Piece parts cannot have controlled children.": "Окремі деталі не можуть містити контрольовані компоненти.",
  "Piece parts do not have assembly configurations.": "Окремі деталі не мають конфігурацій збірок.",
  "Position": "Позиція",
  "Position code": "Код положення",
  "Position codes contain 1–12 uppercase letters.": "Коди положення містять від 1 до 12 великих латинських літер.",
  "Product shown": "Показаний виріб",
  "Product version": "Версія продукту",
  "Product versions": "Версії продукту",
  "Project": "Проєкт",
  "Project / product version": "Проєкт / версія виробу",
  "Project code": "Код проєкту",
  "Project explorer": "Дерево проєктів",
  "Project name": "Назва проєкту",
  "Project settings": "Налаштування проєкту",
  "Project workspace": "Робочий простір проєкту",
  "Projects": "Проєкти",
  "Quantity": "Кількість",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "Кількість і положення належать кожному використанню, а не ідентичності деталі. Обидва коліна вибирають ревізію 1.",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "Кількість має бути додатною, не більшою за мільярд, з не більш ніж шістьма десятковими знаками.",
  "ROBOT project": "Проєкт ROBOT",
  "Reason for changing the code": "Причина зміни коду",
  "Reason for correcting the code": "Причина виправлення коду",
  "Reason for correcting version number": "Причина виправлення номера версії",
  "Regional format": "Регіональний формат",
  "Register code": "Зареєструвати код",
  "Register variant code": "Зареєструвати код варіанта",
  "Registered meanings cannot be reassigned after use.": "Після використання значення зареєстрованих кодів не можна змінювати.",
  "Registered {value0} codes": "Зареєстровані коди: {value0}",
  "Registry": "Реєстр",
  "Related identities are not automatically interchangeable.": "Пов’язані ідентичності не є автоматично взаємозамінними.",
  "Related part": "Пов’язана деталь",
  "Release configuration": "Випустити конфігурацію",
  "Release each selected child revision before releasing this assembly.": "Випустіть усі вибрані ревізії компонентів перед випуском збірки.",
  "Release the assembly revision before releasing this configuration.": "Випустіть ревізію збірки перед випуском конфігурації.",
  "Released": "Випущено",
  "Released arm baseline": "Випущений базовий склад руки",
  "Released configurations cannot be changed. Create a new configuration.": "Випущені конфігурації не можна змінювати. Створіть нову.",
  "Released definitions stay unchanged. Create a new revision to make changes.": "Випущені визначення незмінні. Для змін створіть нову ревізію.",
  "Released structures stay unchanged. Create a new revision.": "Випущені структури незмінні. Створіть нову ревізію.",
  "Reload saved preferences": "Перезавантажити збережені налаштування",
  "Reload structure": "Перезавантажити структуру",
  "Remove": "Видалити",
  "Remove access": "Видалити доступ",
  "Remove alias": "Видалити зовнішній номер",
  "Remove external alias?": "Видалити зовнішній номер?",
  "Remove from assembly": "Видалити зі збірки",
  "Remove from assembly?": "Видалити зі збірки?",
  "Remove saved search": "Видалити збережений пошук",
  "Remove saved search?": "Видалити збережений пошук?",
  "Remove {value0}'s access?": "Видалити доступ для {value0}?",
  "Replace invitation link?": "Замінити посилання запрошення?",
  "Replace link": "Замінити посилання",
  "Replacement": "Заміна",
  "Replacement conditions": "Умови заміни",
  "Results per page": "Результатів на сторінці",
  "Retired": "Виведений",
  "Retry saved change": "Повторити збережену зміну",
  "Reuse & structure": "Повторне використання й структура",
  "Reuse parts": "Повторно використати деталі",
  "Reuse source": "Джерело повторного використання",
  "Rev": "Рев.",
  "Revision": "Ревізія",
  "Revision and configuration numbers must be positive.": "Номери ревізій та конфігурацій мають бути додатними.",
  "Revision structures are selected by revision, not by project snapshot.": "Структури ревізій вибираються за ревізією, а не знімком проєкту.",
  "Revisions": "Ревізії",
  "Revoke invitation": "Відкликати запрошення",
  "Revoke invitation?": "Відкликати запрошення?",
  "Right hand": "Права кисть",
  "Riveted": "Клепане",
  "Riveted assembly": "Клепана збірка",
  "Riveted chest panel": "Клепана панель грудей",
  "Robot numbering guide": "Довідник нумерації робота",
  "Same assembly and revision, different frozen selections.": "Та сама збірка й ревізія, різні зафіксовані набори.",
  "Same cover identity": "Та сама ідентичність кришки",
  "Save": "Зберегти",
  "Save as a new search": "Зберегти як новий пошук",
  "Save changes": "Зберегти зміни",
  "Save configuration": "Зберегти конфігурацію",
  "Save project": "Зберегти проєкт",
  "Save replacement": "Зберегти заміну",
  "Save search": "Зберегти пошук",
  "Saved change recovery": "Відновлення збереженої зміни",
  "Saved searches": "Збережені пошуки",
  "Saving…": "Збереження…",
  "Search": "Пошук",
  "Search columns and order": "Стовпці пошуку та їх порядок",
  "Search company parts": "Шукати деталі компанії",
  "Search filters": "Фільтри пошуку",
  "Search name": "Назва пошуку",
  "Search order": "Порядок пошуку",
  "Search part numbers or names": "Шукати номери або назви деталей",
  "Searching…": "Пошук…",
  "Search…": "Пошук…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "Виберіть кришку, щоб побачити її номер на роботі. Схожа форма не означає однаковий матеріал або визначення.",
  "Select a revision of this assembly.": "Виберіть ревізію цієї збірки.",
  "Select a variant code registered in this company.": "Виберіть код варіанта, зареєстрований у цій компанії.",
  "Select an assembly revision.": "Виберіть ревізію збірки.",
  "Select an exact child revision.": "Виберіть точну ревізію компонента.",
  "Select at least one child occurrence before releasing an assembly configuration.": "Перед випуском конфігурації збірки виберіть щонайменше одне використання компонента.",
  "Selected engineering definition": "Вибране інженерне визначення",
  "Selected revision": "Вибрана ревізія",
  "Send this link to": "Надішліть це посилання",
  "Separable": "Розбірне",
  "Separable assembly": "Розбірна збірка",
  "Several parts use this external alias. Search it and choose the correct part.": "Цей зовнішній номер мають кілька деталей. Знайдіть його та виберіть потрібну деталь.",
  "Show V": "Показати V",
  "Show all company parts": "Показати всі деталі компанії",
  "Show {column}": "Показати {column}",
  "Showing the first": "Показано перші",
  "Shown in product version V": "Показано у версії виробу V",
  "Sign in first.": "Спочатку увійдіть.",
  "Sign in to continue.": "Увійдіть, щоб продовжити.",
  "Sign in to your engineering workspace.": "Увійдіть до інженерного робочого простору.",
  "Sign in with the Google account named on this invitation.": "Увійдіть з обліковим записом Google, зазначеним у запрошенні.",
  "Sign out": "Вийти",
  "Signing in…": "Вхід…",
  "Skip to content": "Перейти до вмісту",
  "Sort": "Сортування",
  "Standard position meanings cannot be changed.": "Значення стандартних положень не можна змінювати.",
  "State": "Стан",
  "Structure": "Структура",
  "Structure snapshot": "Знімок структури",
  "Structure snapshot not found.": "Знімок структури не знайдено.",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "Перемкніться на V2: повторно використані кисті й колінні штифти зберігають номери V1. Лише нова камера отримує номер V2. ROBOT — код проєкту; V1/V2 — версії виробу, а не ревізії деталей.",
  "Switch to {value0} appearance": "Перемкнути оформлення: {value0}",
  "Table density": "Щільність таблиці",
  "That record was not found in this company.": "Цей запис не знайдено в компанії.",
  "The corrected identifier must differ from the current identifier.": "Виправлений ідентифікатор має відрізнятися від поточного.",
  "The correction creates duplicate identifiers.": "Виправлення створює дублікати ідентифікаторів.",
  "The identifier number is outside the supported positive integer range.": "Число в ідентифікаторі поза підтримуваним діапазоном додатних цілих.",
  "The next number changed. Review the updated preview, then issue again.": "Наступний номер змінився. Перегляньте оновлений номер і повторіть видачу.",
  "The number is allocated within its prefix:": "Номер виділяється в межах префікса:",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "Стара деталь зберігає окремий запис. Приклад умови: нова кришка підходить лише з адаптером. Зворотна заміна не передбачається; заміна — не псевдонім.",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "Старе випущене визначення залишається доступним; номер без уточнення визначає деталь, а не «останню ревізію».",
  "The part is saved in the company registry.": "Деталь збережено в реєстрі компанії.",
  "The pending invitation for": "Запрошення, що очікує відповіді для",
  "The prefix is ROBOT-V1.2A.": "Префікс — ROBOT-V1.2A.",
  "The related family must have the same product version and origin parent.": "Пов’язане сімейство повинно мати ту саму версію виробу й початкову батьківську збірку.",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "Не вдалося виконати запит. Повторіть або перезавантажте; перед новим редагуванням підтвердьте незавершену зміну.",
  "The request could not be read. Check your input and try again.": "Не вдалося прочитати запит. Перевірте введені дані та повторіть.",
  "The revision and configuration select different assembly baselines.": "Ревізія та конфігурація вказують на різні базові склади збірки.",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "Однакова форма кришки передпліччя: сріблястий алюміній ліворуч, тканий вуглепластик праворуч",
  "The selected part may replace": "Вибрана деталь може замінювати",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "Спільний номер сімейства не означає взаємозамінність. «Без сторони» не додає уточнення; видача однієї сторони не створює іншу.",
  "This PIN was not found in the selected company.": "Цей PIN не знайдено у вибраній компанії.",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "У цьому базовому складі є кілька ревізій компонента. Явно вкажіть !REV.",
  "This change conflicts with an existing record. Reload and review your changes.": "Зміна конфліктує з наявним записом. Перезавантажте та перегляньте зміни.",
  "This child revision is not in the selected parent baseline.": "Цієї ревізії компонента немає у вибраному батьківському базовому складі.",
  "This code was registered elsewhere. Review its meaning before using it.": "Код зареєстровано в іншому сеансі. Перевірте його значення перед використанням.",
  "This configuration is already released.": "Цю конфігурацію вже випущено.",
  "This destination is read-only or the revision is unavailable.": "Ціль доступна лише для читання або ревізія недоступна.",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "Номер належить іншому сімейству. Створіть пов’язану ідентичність явно.",
  "This identifier is reserved by a historical rename.": "Ідентифікатор зарезервований історичним перейменуванням.",
  "This invitation has expired or been revoked.": "Запрошення прострочене або відкликане.",
  "This invitation has expired, was replaced, or is no longer pending.": "Запрошення прострочене, замінене або вже не очікує відповіді.",
  "This invitation is no longer pending.": "Це запрошення вже не очікує відповіді.",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "Це наступний доступний номер, а не резервування. Під час видачі він перевіряється знову. Якщо його зайняли, форма залишається відкритою з оновленим номером.",
  "This occurrence would create a structure cycle.": "Це використання створило б цикл у структурі.",
  "This part number already exists. Choose a different variant or position.": "Такий номер уже існує. Виберіть інший варіант або положення.",
  "This person is already a member. Change their role in Members.": "Ця особа вже є учасником. Змініть роль у розділі учасників.",
  "This product version number is already assigned.": "Цей номер версії виробу вже призначено.",
  "This project code already exists.": "Цей код проєкту вже існує.",
  "This record changed. Reload it before saving again.": "Запис змінився. Перезавантажте його перед збереженням.",
  "This released configuration does not exist.": "Цієї випущеної конфігурації не існує.",
  "This replacement direction already exists.": "Цей напрямок заміни вже існує.",
  "This revision does not exist.": "Цієї ревізії не існує.",
  "This revision is already released.": "Цю ревізію вже випущено.",
  "This saved search belongs to another person.": "Цей збережений пошук належить іншій особі.",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "Оновлює префікси номерів проєкту. Контрольовані ідентичності зберігають історичні перенаправлення.",
  "Time zone": "Часовий пояс",
  "Try again": "Спробувати знову",
  "Two hands, two identities.": "Дві кисті, дві ідентичності.",
  "Two occurrences, one part": "Два використання, одна деталь",
  "Unit": "Одиниця",
  "Unsaved search": "Незбережений пошук",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "Використовуйте PROJECT-V1, далі вузли ідентичності без початкових нулів.",
  "Use a positive product version number.": "Використовуйте додатний номер версії виробу.",
  "Use a positive, unpadded family number.": "Використовуйте додатний номер сімейства без початкових нулів.",
  "Use a whole number for the search filter.": "Використовуйте ціле число у фільтрі пошуку.",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "Код має починатися великою латинською літерою та містити великі літери, цифри або дефіси, до 32 символів.",
  "Use code": "Використати код",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "Використовуйте число/тип, необов’язкові !VARIANT і #POSITION, потім !REV і !CFG саме в такому порядку. Початкові нулі та двокрапки неприпустимі.",
  "Using this pin in V2 or another project in the same company keeps": "Використання цього штифта у V2 або іншому проєкті компанії зберігає",
  "V1 tells you where a part was first numbered.": "V1 показує, де деталь уперше отримала номер.",
  "Variant code": "Код варіанта",
  "Variant codes": "Коди варіантів",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "Коди варіантів містять великі латинські літери та не можуть починатися з REV або CFG.",
  "Variants & replacements": "Варіанти й заміни",
  "Version name": "Назва версії",
  "Version name (optional)": "Назва версії (необов’язково)",
  "Version number": "Номер версії",
  "View parts": "Переглянути деталі",
  "Viewer": "Читач",
  "Wait for a valid part-number preview.": "Дочекайтеся коректного попереднього номера деталі.",
  "Welded": "Зварне",
  "Welded assembly": "Зварна збірка",
  "Welded torso frame": "Зварний каркас тулуба",
  "Where used": "Де використано",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "За наявності контрольованих залежностей старий текст перенаправляє на перейменовану деталь. !REV1 і далі відкриває точну історичну ревізію; конфігурації й нумерація нащадків зберігаються.",
  "Withdraw permission for": "Відкликати дозвіл для",
  "Withdraw replacement": "Відкликати заміну",
  "Withdraw replacement?": "Відкликати заміну?",
  "You are already a member of this company.": "Ви вже є учасником цієї компанії.",
  "Your form session expired. Refresh your session, then retry the saved change.": "Сеанс форми завершився. Оновіть сеанс, потім повторіть збережену зміну.",
  "Your preferences changed. Reload before saving again.": "Ваші налаштування змінилися. Перезавантажте їх перед збереженням.",
  "across this company": "у всій компанії",
  "and": "і",
  "at {value0}": "у {value0}",
  "dark": "темне",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "розрізняють праву й ліву форми. Виноски вказують на власні кисті робота, а не на сторони глядача.",
  "from": "з",
  "from this structure? The original part remains in the company registry.": "з цієї структури? Оригінальна деталь залишається в реєстрі компанії.",
  "in this example.": "у цьому прикладі.",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "— тип конструкції, а не ревізія. P — окрема деталь без контрольованих компонентів; A, W, G і R — збірки з різними способами з’єднання.",
  "issued.": "видано.",
  "light": "світле",
  "match": "збіг",
  "matches": "збігів",
  "mm": "mm",
  "of": "з",
  "only under the stated conditions.": "лише за вказаних умов.",
  "parts. Search the company to find additional matches.": "деталей. Шукайте в компанії, щоб знайти інші збіги.",
  "to replace": "для заміни",
  "will lose access to every project and part in this company.": "втратить доступ до всіх проєктів і деталей компанії.",
  "will no longer work.": "більше не працюватиме.",
  "{field} must contain {minimum}–{maximum} characters.": "{field}: від {minimum} до {maximum} символів.",
  "{value0} added to {value1}.": "{value0} додано до {value1}.",
  "{value0} code": "Код: {value0}",
  "{value0} cover example": "Приклад кришки: {value0}",
  "{value0} editor": "Редактор: {value0}",
  "{value0} meaning": "Значення: {value0}",
  "{value0} · Rev {value1}": "{value0} · Рев. {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· по 1 шт.",
  "· Refine your search for other matches.": "· Уточніть пошук для інших збігів.",
  "· Revision {value0}": "· Ревізія {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF змінює ідентичність, а не ревізію.",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "? Визначення й точні використання компонентів стануть незмінними. Подальші зміни потребуватимуть нової ревізії.",
  "Accept invitation": "Прийняти запрошення",
  "Accepting…": "Прийняття…",
  "Actions": "Дії",
  "Actions for {value0}": "Дії для {value0}",
  "Add description": "Додати опис",
  "Add external alias": "Додати зовнішній номер",
  "An origin parent is selected.": "Вибрано початкову батьківську збірку.",
  "Applicability / effectivity": "Застосовність / чинність",
  "Apply identity correction": "Застосувати виправлення ідентичності",
  "Assembly revision": "Ревізія збірки",
  "Both covers share": "Обидві кришки мають спільний",
  "Change role": "Змінити роль",
  "Checking number…": "Перевірка номера…",
  "Child REV": "Рев. компонента",
  "Choose a project": "Виберіть проєкт",
  "Choose a revision to inspect its exact definition.": "Виберіть ревізію для перегляду її точного визначення.",
  "Choose a revision to view its exact structure.": "Виберіть ревізію для перегляду її точної структури.",
  "Choose an assembly in the selected product version.": "Виберіть збірку у вибраній версії виробу.",
  "Choose an exact assembly revision.": "Виберіть точну ревізію збірки.",
  "Choose another company": "Вибрати іншу компанію",
  "Collapse": "Згорнути",
  "Company access unavailable": "Доступ до компанії недоступний",
  "Copied.": "Скопійовано.",
  "Copy link": "Копіювати посилання",
  "Copy was unavailable. Select the link and copy it manually.": "Копіювання недоступне. Виділіть посилання й скопіюйте вручну.",
  "Correct identity": "Виправити ідентичність",
  "Custom position…": "Власне положення…",
  "Definition": "Визначення",
  "Details for {value0}": "Відомості про {value0}",
  "Edit": "Редагування",
  "Edit alias {value}": "Редагувати зовнішній номер {value}",
  "Edit definition": "Редагувати визначення",
  "Edit external alias": "Редагувати зовнішній номер",
  "Empty definition": "Порожнє визначення",
  "Expand": "Розгорнути",
  "Family number": "Номер сімейства",
  "Freeze CFG": "Зафіксувати CFG",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "Вхід Google не налаштовано. Адміністратор має відновити налаштування входу.",
  "Identity": "Ідентичність",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "У компанії з прикладу CF зареєстровано як «вуглепластик». Інші компанії можуть мати інше значення.",
  "Include selected revision": "Додати вибрану ревізію",
  "Invitations": "Запрошення",
  "Join": "З’єднання",
  "Left": "Ліва",
  "Next": "Далі",
  "No child parts.": "Немає дочірніх деталей.",
  "No companies yet.": "Компаній ще немає.",
  "No configurations yet.": "Конфігурацій ще немає.",
  "No external aliases.": "Зовнішніх номерів немає.",
  "No invitations.": "Запрошень немає.",
  "No matching choices.": "Відповідних варіантів немає.",
  "No matching parts.": "Відповідних деталей немає.",
  "No parts in this structure yet.": "У цій структурі ще немає деталей.",
  "No product versions in this project.": "У цьому проєкті немає версій виробу.",
  "No product versions yet.": "Версій виробу ще немає.",
  "No projects yet.": "Проєктів ще немає.",
  "No replacement relationships.": "Зв’язків заміни немає.",
  "No variant code": "Без коду варіанта",
  "No variant codes registered.": "Коди варіантів не зареєстровані.",
  "Not reserved": "Не зарезервовано",
  "Numbered directly under the product version.": "Номер безпосередньо під версією виробу.",
  "Open assembly {value0}": "Відкрити збірку {value0}",
  "Open resolved configuration": "Відкрити знайдену конфігурацію",
  "Origin product version": "Початкова версія виробу",
  "Other positions": "Інші положення",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "Інші положення додають уточнення ідентичності: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR та #TOP/#MIDVERT/#BOTTOM. Два «середніх» належать різним осям. Власні коди мають значення, визначене компанією. Це не місце використання деталі в збірці.",
  "Other positions…": "Інші положення…",
  "Page {page} of {pages}": "Сторінка {page} з {pages}",
  "Part / P/N": "Деталь / номер",
  "Part section not found.": "Розділ деталі не знайдено.",
  "Parts in {value0}": "Деталі у {value0}",
  "Person": "Людина",
  "Piece parts have no child structure.": "Окремі деталі не мають дочірньої структури.",
  "Position for occurrence {value0}": "Положення використання {value0}",
  "Previous": "Назад",
  "Product root": "Корінь виробу",
  "Product structure": "Структура продукту",
  "Qty": "К-сть",
  "Quantity for occurrence {value0}": "Кількість використання {value0}",
  "Quantity for {value0} {value1}": "Кількість для {value0} {value1}",
  "Quantity saved for {value0}.": "Кількість для {value0} збережено.",
  "Read-only access": "Доступ лише для читання",
  "Reason for correction": "Причина виправлення",
  "Registered variant": "Зареєстрований варіант",
  "Release": "Випустити",
  "Release revision": "Випустити ревізію",
  "Remove alias {value}": "Видалити зовнішній номер {value}",
  "Remove from assembly {value0} {value1}": "Видалити зі збірки {value0} {value1}",
  "Remove selected occurrence": "Видалити вибране використання",
  "Remove {value0}'s access": "Видалити доступ для {value0}",
  "Replace invitation link for {value0}": "Замінити посилання запрошення для {value0}",
  "Reset quantity for {value0}": "Скинути кількість для {value0}",
  "Resolved definition: REV": "Знайдене визначення: REV",
  "Results: {count}": "Результати: {count}",
  "Retry preview": "Повторити попередній перегляд",
  "Revoke": "Відкликати",
  "Revoke invitation for {value0}": "Відкликати запрошення для {value0}",
  "Right": "Права",
  "Role": "Роль",
  "Same family number, different identities.": "Той самий номер сімейства, різні ідентичності.",
  "Save quantity for {value0}": "Зберегти кількість для {value0}",
  "Search pages": "Сторінки пошуку",
  "Source product version": "Початкова версія виробу",
  "Source project": "Початковий проєкт",
  "Start from": "Почати з",
  "Structural class": "Тип конструкції",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "Запрошення створено, але одноразове посилання більше не можна показати. Скористайтеся заміною посилання, щоб створити нове.",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "Посилання запрошення неповне. Попросіть власника компанії надати нове.",
  "This part is not used in a structure or configuration.": "Ця деталь не використовується у структурах або конфігураціях.",
  "This structure is read-only. Choose a draft revision to edit.": "Структура лише для читання. Для редагування виберіть чернетку ревізії.",
  "Unit & position": "Одиниця й положення",
  "Unit for occurrence {value0}": "Одиниця використання {value0}",
  "Unspecified": "Не вказано",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "Невикористані призначення виправляються напряму. Контрольовані ідентичності перейменовуються атомарно з історичними перенаправленнями; ревізії, конфігурації та використання зберігаються.",
  "Use product-version root": "Використати корінь версії виробу",
  "Variant": "Варіант",
  "Versions": "Версії",
  "You do not have company access yet. Open an invitation from a company owner.": "Ви ще не маєте доступу до компанії. Відкрийте запрошення від її власника.",
  "Your account does not have access to this company.": "Ваш обліковий запис не має доступу до цієї компанії.",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "та вибрані точні ревізії компонентів? Збірка й усі ревізії компонентів мають бути вже випущені.",
  "as": "як",
  "because the new cover was explicitly numbered as related to the existing one.": "оскільки нову кришку явно пронумеровано як пов’язану з наявною.",
  "may replace": "може замінювати",
  "using": "з використанням",
  "· Expires": "· Термін дії",
  "Sign in again": "Увійти знову",
  "Refresh session": "Оновити сеанс",
  "Connection interrupted. Check the saved change before making another edit.": "З’єднання перервано. Перевірте збережену зміну перед новим редагуванням.",
  "The request could not be completed.": "Не вдалося виконати запит.",
  "Resolve the saved change shown above before making another edit.": "Підтвердьте результат збереженої зміни перед новим редагуванням.",
  "Browser storage is unavailable. Enable it before saving a change.": "Сховище браузера недоступне. Увімкніть його перед збереженням зміни.",
  "No position": "Без положення",
  "Not specified.": "Не вказано.",
  "No description.": "Без опису.",
  "Field": "Поле",
  "Choose…": "Виберіть…",
  "Choose": "Вибрати",
  "Complete {field}.": "Заповніть поле «{field}».",
  "Check the value of {field}.": "Перевірте значення поля «{field}».",
  "Do not submit another edit until this change is confirmed.": "Не надсилайте нові зміни до підтвердження цієї.",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 зберігає кришку REV1; CFG2 вибирає REV2. Конфігурація не є новим номером і застосовується лише до збірок.",
  "No variant": "Без варіанта",
  "Company created": "Компанію створено",
  "Company updated": "Компанію оновлено",
  "Variant code registered": "Код варіанта зареєстровано",
  "Position code registered": "Код положення зареєстровано",
  "Role changed": "Роль змінено",
  "Membership removed": "Доступ учасника видалено",
  "Invitation created": "Запрошення створено",
  "Invitation link replaced": "Посилання запрошення замінено",
  "Invitation revoked": "Запрошення відкликано",
  "Invitation accepted": "Запрошення прийнято",
  "Revision created": "Ревізію створено",
  "Revision definition updated": "Визначення ревізії оновлено",
  "Revision released": "Ревізію випущено",
  "Structure occurrence added": "Деталь додано до структури",
  "Structure occurrence updated": "Використання деталі оновлено",
  "Structure occurrence removed": "Деталь видалено зі структури",
  "Configuration created": "Конфігурацію створено",
  "Configuration updated": "Конфігурацію оновлено",
  "Configuration released": "Конфігурацію випущено",
  "Replacement recorded": "Заміну записано",
  "Replacement withdrawn": "Заміну відкликано",
  "Project created": "Проєкт створено",
  "Project updated": "Проєкт оновлено",
  "Product version created": "Версію виробу створено",
  "Product version updated": "Версію виробу оновлено",
  "Part issued": "Номер деталі видано",
  "Part details updated": "Відомості деталі оновлено",
  "alias-added": "Зовнішній номер додано",
  "alias-edited": "Зовнішній номер змінено",
  "alias-removed": "Зовнішній номер видалено",
  "Identity renamed": "Ідентичність перейменовано",
  "Assignment corrected": "Призначення виправлено",
  "North": "Північ",
  "South": "Південь",
  "West": "Захід",
  "East": "Схід",
  "Front": "Перед",
  "Rear": "Зад",
  "Mid": "Середина",
  "Top": "Верх",
  "Bottom": "Низ",
  "Side": "Сторона",
  "North / south": "Північ / південь",
  "West / east": "Захід / схід",
  "Front / rear": "Перед / зад",
  "Top / bottom": "Верх / низ",
  "Custom": "Власне",
  "Family, not an orderable P/N": "Сімейство, а не номер для замовлення",
  "Pending": "Очікує",
  "Accepted": "Прийнято",
  "Revoked": "Відкликано",
  "Expired": "Термін минув",
  "Edit revision definition": "Редагувати визначення ревізії",
  "Release revision?": "Випустити ревізію?",
  "Release configuration?": "Випустити конфігурацію?",
  "A complete SHA-256 checksum is required.": "Потрібна повна контрольна сума SHA-256.",
  "Add comment": "Додати коментар",
  "Add file": "Додати файл",
  "All": "Усі",
  "Applicability": "Застосовність",
  "Applicability must refer to a configuration of the owning part.": "Застосовність має посилатися на конфігурацію деталі, якій належить документ.",
  "Applicability must refer to a revision of the owning part.": "Застосовність має посилатися на ревізію деталі, якій належить документ.",
  "Applicability notes": "Примітки щодо застосовності",
  "Attachment": "Вкладення",
  "Cancel upload": "Скасувати завантаження",
  "Cancelled": "Скасовано",
  "Checking file…": "Перевірка файлу…",
  "Choose Draft or Issued status.": "Виберіть статус «Чернетка» або «Випущено».",
  "Choose Source, Rendition or Attachment.": "Виберіть «Вихідний файл», «Версія для перегляду» або «Вкладення».",
  "Choose a draft document or production job for this file.": "Виберіть чернетку документа або виробниче завдання для цього файлу.",
  "Choose a file of this revision.": "Виберіть файл цієї ревізії.",
  "Choose a registered document type.": "Виберіть зареєстрований тип документа.",
  "Choose a supported document owner.": "Виберіть підтримуваного власника документа.",
  "Choose a valid results page and a positive page size.": "Виберіть дійсну сторінку результатів і додатну кількість результатів на сторінці.",
  "Choose an issued revision of this document.": "Виберіть випущену ревізію цього документа.",
  "Choose the viewed revision of this document.": "Виберіть ревізію цього документа, яку переглядаєте.",
  "Choose this company as the document owner.": "Виберіть цю компанію власником документа.",
  "Clear applicability references": "Очистити посилання застосовності",
  "Comment": "Коментар",
  "Comment history": "Історія коментаря",
  "Comment removed": "Коментар видалено",
  "Copy this revision into a shared editable draft?": "Скопіювати цю ревізію до спільної редагованої чернетки?",
  "Create document": "Створити документ",
  "Create shared draft": "Створити спільну чернетку",
  "Deleted comments retain their history and cannot be edited.": "Історія видалених коментарів зберігається; редагувати їх не можна.",
  "Discussion": "Обговорення",
  "Document comment added": "Додано коментар до документа",
  "Document comment deleted": "Видалено коментар до документа",
  "Document comment edited": "Змінено коментар до документа",
  "Document created": "Документ створено",
  "Document draft created": "Чернетку документа створено",
  "Document draft updated": "Чернетку документа оновлено",
  "Document file": "Файл документа",
  "Document file linked": "Файл пов’язано з документом",
  "Document file unlinked": "Зв’язок файлу з документом видалено",
  "Document files published": "Файли документа опубліковано",
  "Document files unpublished": "Публічний доступ до файлів документа припинено",
  "Document information": "Відомості про документ",
  "Document issued": "Документ випущено",
  "Document number": "Номер документа",
  "Document reader": "Перегляд документа",
  "Document type": "Тип документа",
  "Document type registered": "Тип документа зареєстровано",
  "Documents": "Документи",
  "Download {name}": "Завантажити {name}",
  "Edit comment": "Редагувати коментар",
  "Edit draft": "Редагувати чернетку",
  "Edit history": "Історія редагувань",
  "Exact engineering applicability": "Точна інженерна застосовність",
  "Exact revision": "Точна ревізія",
  "File": "Файл",
  "File name": "Назва файлу",
  "File purpose": "Призначення файлу",
  "File size must be between 1 byte and 20 GiB.": "Розмір файлу має бути від 1 байта до 20 ГіБ.",
  "File storage is not configured.": "Сховище файлів не налаштовано.",
  "File unavailable": "Файл недоступний",
  "Files": "Файли",
  "Files available to anyone with the public link": "Файли доступні всім, хто має публічне посилання",
  "Files can only be added to a draft document.": "Файли можна додавати лише до чернетки документа.",
  "Identifier filter": "Фільтр за ідентифікатором",
  "Issue revision": "Випустити ревізію",
  "Issue this exact revision? Its metadata and files will become immutable.": "Випустити саме цю ревізію? Її метадані та файли більше не можна буде змінити.",
  "Issued": "Випущено",
  "Issued revisions are immutable. Create a shared draft to make changes.": "Випущені ревізії не можна змінювати. Для внесення змін створіть спільну чернетку.",
  "Link at least one verified file before issuing.": "Перед випуском приєднайте щонайменше один перевірений файл.",
  "New file": "Новий файл",
  "No comments yet.": "Коментарів ще немає.",
  "No files in this revision.": "У цій ревізії немає файлів.",
  "No published files.": "Немає опублікованих файлів.",
  "No revisions available.": "Немає доступних ревізій.",
  "Only an unfinished upload can be cancelled.": "Можна скасувати лише незавершене завантаження.",
  "Only issued files can be published.": "Опублікувати можна лише файли випущених ревізій.",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "Приєднати або випустити можна лише незмінні файли з перевіреним розміром і контрольною сумою SHA-256.",
  "Open public link": "Відкрити публічне посилання",
  "Owner kind": "Тип власника",
  "Page {page} · {count} documents": "Сторінка {page} · Документів: {count}",
  "Part revision": "Ревізія деталі",
  "Pause": "Призупинити",
  "Paused": "Призупинено",
  "Preview is not available for this file. Download it instead.": "Попередній перегляд цього файлу недоступний. Завантажте його.",
  "Preview unavailable. Download the file to view it.": "Попередній перегляд недоступний. Завантажте файл для перегляду.",
  "Public description": "Публічний опис",
  "Public links": "Публічні посилання",
  "Public title": "Публічна назва",
  "Publication not found.": "Публікацію не знайдено.",
  "Publish selected files": "Опублікувати вибрані файли",
  "Published document not found.": "Опублікований документ не знайдено.",
  "Published file not found.": "Опублікований файл не знайдено.",
  "Register document type": "Зареєструвати тип документа",
  "Reload revision": "Перезавантажити ревізію",
  "Remove comment": "Видалити коментар",
  "Remove file": "Видалити файл",
  "Remove this comment? Its edit history is retained.": "Видалити цей коментар? Історія його редагувань збережеться.",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "Видалити цей файл із чернетки? Файли раніше випущених ревізій збережуться.",
  "Remove {name}": "Видалити {name}",
  "Rendition": "Версія для перегляду",
  "Resume this upload with the recorder who started it.": "Відновіть це завантаження від імені реєстратора, який його розпочав.",
  "Resume upload": "Відновити завантаження",
  "Revision unavailable": "Ревізія недоступна",
  "Revision {number}": "Ревізія {number}",
  "Revision {number} · {status}": "Ревізія {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "Пошук документів",
  "Select distinct issued files to publish.": "Виберіть різні файли випущеної ревізії для публікації.",
  "Select files from this exact issued revision.": "Виберіть файли саме цієї випущеної ревізії.",
  "Select the same file to resume this upload.": "Виберіть той самий файл, щоб відновити завантаження.",
  "Source": "Вихідний файл",
  "Status": "Статус",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "Припинити подальший доступ за цим публічним посиланням? Уже завантажені копії не буде видалено.",
  "That document revision was not found in this company.": "Цю ревізію документа не знайдено в цій компанії.",
  "The configuration must select the exact applicability revision.": "Конфігурація має вказувати точну ревізію застосовності.",
  "The document input changed during capture. Retry the same request.": "Дані документа змінилися під час запису. Повторіть той самий запит.",
  "The file upload is not complete.": "Завантаження файлу не завершено.",
  "The issued files no longer match their immutable manifest.": "Файли випущеної ревізії більше не відповідають їхньому незмінному маніфесту.",
  "The issued manifest failed integrity verification.": "Маніфест випущеної ревізії не пройшов перевірку цілісності.",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "Контрольна сума завантаженого файлу не збігається. Скасуйте це завантаження та знову виберіть вихідний файл.",
  "The uploaded file is unavailable.": "Завантажений файл недоступний.",
  "The verified file must belong to this document.": "Перевірений файл має належати цьому документу.",
  "This comment is already deleted.": "Цей коментар уже видалено.",
  "This document already has a shared draft.": "Цей документ уже має спільну чернетку.",
  "This document numbering sequence is exhausted.": "Послідовність нумерації цих документів вичерпано.",
  "This file is not available.": "Цей файл недоступний.",
  "This file is unavailable. Contact the company owner.": "Цей файл недоступний. Зверніться до власника компанії.",
  "This revision changed. Reload it before publishing.": "Ця ревізія змінилася. Перезавантажте її перед публікацією.",
  "This upload cannot be verified.": "Це завантаження неможливо перевірити.",
  "This upload is no longer writable.": "До цього завантаження більше не можна записувати дані.",
  "This upload was not found.": "Це завантаження не знайдено.",
  "Title": "Назва",
  "Title filter": "Фільтр за назвою",
  "Type code": "Код типу",
  "Type name": "Назва типу",
  "Unpublish": "Припинити публікацію",
  "Unpublished": "Публікацію припинено",
  "Upload file": "Завантажити файл",
  "Uploaded": "Завантажено",
  "Uploading…": "Завантаження…",
  "Use a file name without a path or control characters.": "Укажіть назву файлу без шляху та керувальних символів.",
  "Use a file name without directory separators.": "Укажіть назву файлу без роздільників каталогів.",
  "Use an uppercase alphanumeric type code starting with a letter.": "Укажіть код типу з великих латинських літер і цифр, що починається з літери.",
  "Verified": "Перевірено",
  "Verifying file…": "Підтвердження цілісності файлу…",
  "View draft": "Переглянути чернетку",
  "file-upload-created": "Розпочато завантаження файлу",
  "file-verified": "Файл перевірено",
  "{bytes} bytes": "Байтів: {bytes}",
  "No matching documents.": "Немає відповідних документів.",
  "No documents yet.": "Документів ще немає.",
  "The revision’s applicability details could not be loaded. Try again.": "Не вдалося завантажити відомості про застосовність ревізії. Спробуйте ще раз.",
  "Comment authors could not be loaded. Try again.": "Не вдалося завантажити авторів коментарів. Спробуйте ще раз.",
  "Comment history authors could not be loaded. Try again.": "Не вдалося завантажити авторів змін коментаря. Спробуйте ще раз.",
  "Choose a saved search": "Виберіть збережений пошук",
  "This saved search belongs to another person or collection.": "Цей збережений пошук належить іншій особі або колекції.",
  "Choose a saved parts search.": "Виберіть збережений пошук деталей.",
  "Supply document search filters.": "Укажіть фільтри пошуку документів.",
  "Pages": "Сторінки",
  "{from}–{to} of {total}": "{from}–{to} з {total}",
  "Choose lot": "Вибрати партію",
  "Choose material": "Вибрати матеріал",
  "No matches": "Збігів немає",
  "Stock": "Запаси",
  "Lots": "Партії",
  "Materials": "Матеріали",
  "Supplier": "Постачальник",
  "Material identifier": "Ідентифікатор матеріалу",
  "Specification": "Специфікація",
  "Reload latest versions": "Завантажити актуальні версії",
  "Edit material": "Редагувати матеріал",
  "Create material revision": "Створити ревізію матеріалу",
  "Edit material revision": "Редагувати ревізію матеріалу",
  "Release material revision": "Випустити ревізію матеріалу",
  "Create lot": "Створити партію",
  "Choose an exact material revision.": "Виберіть конкретну ревізію матеріалу.",
  "Lot identifier": "Ідентифікатор партії",
  "Balances": "Залишки",
  "No stock recorded": "Запаси не зареєстровано",
  "Genealogy": "Походження партій",
  "No linked lots": "Пов’язаних партій немає",
  "To": "До",
  "Reversed": "Сторновано",
  "Movement details": "Деталі руху запасів",
  "Record history": "Історія запису",
  "Movements": "Рух запасів",
  "Movement type": "Тип руху запасів",
  "No movements recorded": "Рух запасів не зареєстровано",
  "Original movement": "Початковий рух запасів",
  "Replaced movement": "Замінений рух запасів",
  "Reversal": "Сторнування",
  "Reverse movement": "Сторнувати рух запасів",
  "Record replacement": "Зареєструвати заміну",
  "Movement warnings unavailable": "Попередження щодо руху запасів недоступні",
  "Warnings": "Попередження",
  "Actual quantity": "Фактична кількість",
  "Location": "Місце зберігання",
  "Disposition": "Стан придатності",
  "Use balance location": "Використати місце зберігання залишку",
  "Wait for the latest balances.": "Дочекайтеся актуальних залишків.",
  "Choose a lot for every quantity.": "Виберіть партію для кожної кількості.",
  "Source {number}": "Джерело {number}",
  "Remove source": "Видалити джерело",
  "Add source": "Додати джерело",
  "Output {number}": "Вихід {number}",
  "Remove output": "Видалити вихід",
  "Add output": "Додати вихід",
  "Destination location": "Місце призначення",
  "Source reference": "Посилання на джерело",
  "Reason": "Причина",
  "Reload latest balances": "Завантажити актуальні залишки",
  "Receipt": "Надходження",
  "Accept": "Прийняти",
  "Quarantine": "Помістити на карантин",
  "Transfer": "Переміщення",
  "Consume": "Списати у виробництво",
  "Scrap": "Списати у брак",
  "Split": "Розділити",
  "Merge": "Об’єднати",
  "MaterialLots": "Партії матеріалів",
  "Receipts": "Надходження",
  "Create material": "Створити матеріал",
  "Search lots": "Пошук партій",
  "Search materials": "Пошук матеріалів",
  "Select a lot": "Виберіть партію",
  "Select a material": "Виберіть матеріал",
  "Supplier reference": "Номер у постачальника",
  "Supplier lot reference": "Номер партії постачальника",
  "Material created": "Матеріал створено",
  "Material renamed": "Матеріал перейменовано",
  "Material revision created": "Ревізію матеріалу створено",
  "Material revision edited": "Ревізію матеріалу відредаговано",
  "Material revision released": "Ревізію матеріалу випущено",
  "Lot created": "Партію створено",
  "Correction": "Виправлення",
  "Record updated": "Запис оновлено",
  "All movements": "Усі рухи запасів",
  "Quarantined": "На карантині",
  "Not recorded": "Не зареєстровано",
  "No matching records.": "Відповідних записів немає.",
  "Page": "Сторінка",
  "Evidence warnings": "Попередження щодо підтвердних матеріалів",
  "Production": "Виробництво",
  "Create job": "Створити виробниче завдання",
  "Routes": "Технологічні маршрути",
  "Search jobs": "Пошук виробничих завдань",
  "Clear part filter": "Скинути фільтр деталей",
  "No jobs found.": "Виробничих завдань не знайдено.",
  "Select a job to review or record actual work.": "Виберіть завдання, щоб переглянути або зареєструвати фактичну роботу.",
  "Change": "Змінити",
  "Select an exact definition revision.": "Виберіть конкретну ревізію визначення.",
  "Job identifier": "Ідентифікатор завдання",
  "Route input": "Вхідний технологічний маршрут",
  "Document inputs": "Вхідні документи",
  "Select route": "Вибрати маршрут",
  "Back": "Назад",
  "Create route": "Створити маршрут",
  "Create route revision": "Створити ревізію маршруту",
  "Choose another route": "Вибрати інший маршрут",
  "Inspection expected": "Передбачено контроль",
  "Route name": "Назва маршруту",
  "Operation": "Операція",
  "Instructions": "Інструкції",
  "Move up": "Перемістити вгору",
  "Move down": "Перемістити вниз",
  "Remove operation": "Видалити операцію",
  "Add operation": "Додати операцію",
  "Serials": "Серійні одиниці",
  "ProductionOutputs": "Випуск продукції",
  "Operations": "Операції",
  "Inspections": "Перевірки",
  "Declarations": "Декларації",
  "Back to collection": "Назад до списку",
  "Recorded at": "Дата й час реєстрації",
  "Created": "Створено",
  "Display columns": "Відображення стовпців",
  "Import records": "Імпортувати записи",
  "Preview records": "Попередній перегляд записів",
  "New preview": "Новий попередній перегляд",
  "Apply valid rows": "Застосувати коректні рядки",
  "Reload preview": "Завантажити перегляд знову",
  "Row {number}": "Рядок {number}",
  "Applied": "Застосовано",
  "Apply row": "Застосувати рядок",
  "Source name": "Назва джерела",
  "Record type": "Тип запису",
  "Download CSV template": "Завантажити шаблон CSV",
  "CSV file": "Файл CSV",
  "Previous imports": "Попередні імпорти",
  "Manual entry": "Ручне введення",
  "Choose a CSV file.": "Виберіть файл CSV.",
  "The CSV file exceeds the import size limit.": "Файл CSV перевищує допустимий розмір імпорту.",
  "Serial number": "Серійний номер",
  "Output source reference": "Посилання на джерело випуску",
  "Step": "Крок",
  "Result": "Результат",
  "Actual result": "Фактичний результат",
  "Kind": "Вид",
  "Value": "Значення",
  "Exact configuration": "Конкретна конфігурація",
  "Exact route revision": "Конкретна ревізія маршруту",
  "Material definition": "Визначення матеріалу",
  "Primary definition": "Основне визначення",
  "Route revision": "Ревізія маршруту",
  "Record output": "Зареєструвати випуск",
  "Record operation": "Зареєструвати операцію",
  "Record inspection": "Зареєструвати перевірку",
  "Record consumption or component": "Зареєструвати витрату або компонент",
  "Declare output": "Задекларувати випуск",
  "Capture as-built": "Зафіксувати фактичну конфігурацію",
  "Unnamed record": "Запис без назви",
  "Serial": "Серійний номер",
  "None available": "Немає доступних",
  "The selected job was not found in an editable company.": "Вибране завдання не знайдено в компанії з доступом до редагування.",
  "Offline job": "Автономне завдання",
  "Download selected job": "Завантажити вибране завдання",
  "Offline work": "Автономна робота",
  "Selected job and files saved for offline use.": "Вибране завдання та файли збережено для автономної роботи.",
  "Download": "Завантажити",
  "bytes": "байтів",
  "Find material lots": "Знайти партії матеріалів",
  "Find component parts": "Знайти деталі-компоненти",
  "Correct recorded work": "Виправити зареєстровану роботу",
  "Save correction": "Зберегти виправлення",
  "Save offline": "Зберегти автономно",
  "Wait for evidence to finish saving.": "Дочекайтеся збереження підтвердних матеріалів.",
  "Choose an output with a recorded version.": "Виберіть випуск із зареєстрованою версією.",
  "Reconnect and load current records before saving a correction.": "Відновіть з’єднання та завантажте актуальні записи перед збереженням виправлення.",
  "Confirm that this correction uses the current stock version.": "Підтвердьте, що виправлення використовує актуальну версію запасів.",
  "The original recording is retained. Review current records before submitting a separate correction.": "Початковий запис зберігається. Перегляньте актуальні записи перед поданням окремого виправлення.",
  "Loading current records": "Завантаження актуальних записів",
  "Current stock": "Поточні запаси",
  "Completed": "Завершено",
  "Failed": "Невдача",
  "Skipped": "Пропущено",
  "InProgress": "У процесі",
  "Passed": "Пройдено",
  "Inconclusive": "Без однозначного висновку",
  "I reviewed the stock conflict and authorize this correction against current stock.": "Я перевірив(-ла) конфлікт запасів і дозволяю це виправлення з урахуванням поточних запасів.",
  "Quality": "Якість",
  "NotStarted": "Не розпочато",
  "Rejected": "Відхилено",
  "As-built": "Фактична конфігурація",
  "Evidence file": "Файл підтвердних матеріалів",
  "Saving evidence locally": "Локальне збереження підтвердних матеріалів",
  "The correction retains the original evidence attachments.": "Виправлення зберігає початкові вкладення підтвердних матеріалів.",
  "Reconnect to verify recorder access before continuing.": "Відновіть з’єднання, щоб перевірити доступ реєстратора перед продовженням.",
  "Reconnect as the original offline recorder.": "Відновіть з’єднання як початковий автономний реєстратор.",
  "Offline recording access was revoked. Recorded work is retained.": "Доступ до автономної реєстрації відкликано. Зареєстровану роботу збережено.",
  "Reconnect": "Відновити з’єднання",
  "Loading": "Завантаження",
  "No offline job is open. Download a selected production job while connected.": "Автономне завдання не відкрито. Завантажте вибране виробниче завдання за наявності з’єднання.",
  "Selected job": "Вибране завдання",
  "Online": "У мережі",
  "Offline": "Без мережі",
  "Resume download": "Продовжити завантаження",
  "Synchronize": "Синхронізувати",
  "Close offline session": "Закрити автономний сеанс",
  "Captured operations": "Зафіксовані операції",
  "No route captured": "Маршрут не зафіксовано",
  "Recorded inspections": "Зареєстровані перевірки",
  "Outputs": "Випуск продукції",
  "No outputs recorded": "Випуск продукції не зареєстровано",
  "Downloaded files": "Завантажені файли",
  "Material lots": "Партії матеріалів",
  "Record work": "Зареєструвати роботу",
  "Recorded commands": "Зареєстровані дії",
  "No local commands recorded": "Локальні дії не зареєстровано",
  "Retained original; correction recorded": "Оригінал збережено; виправлення зареєстровано",
  "Retry unchanged": "Повторити без змін",
  "Saved evidence": "Збережені підтвердні матеріали",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "Закривайте лише після прийняття всієї зареєстрованої роботи та підтвердних матеріалів. Локальна історія залишається доступною.",
  "Offline storage is unavailable in this browser.": "Автономне сховище недоступне в цьому браузері.",
  "The offline application could not be downloaded. Try again online.": "Не вдалося завантажити автономний застосунок. Спробуйте ще раз у мережі.",
  "The offline application is not ready. Reload online and try again.": "Автономний застосунок не готовий. Перезавантажте сторінку в мережі та спробуйте ще раз.",
  "An offline update is waiting. Close other registry tabs and reload online.": "Очікує оновлення автономного застосунку. Закрийте інші вкладки реєстру та перезавантажте сторінку в мережі.",
  "Verified files": "Перевірені файли",
  "Component part": "Деталь-компонент",
  "Component serials": "Серійні одиниці компонентів",
  "Output": "Випуск",
  "Reserved serial": "Зарезервована серійна одиниця",
  "Output lot": "Партія випущеної продукції",
  "Operation order": "Порядок операції",
  "Shared run": "Спільний виробничий запуск",
  "Rework of": "Переробка операції",
  "Inspection": "Перевірка",
  "Actual": "Фактичне значення",
  "Operation attempt": "Спроба виконання операції",
  "Material lot": "Партія матеріалу",
  "Component serial": "Серійна одиниця компонента",
  "Actual revision": "Фактична ревізія",
  "Declaration": "Декларація",
  "Declared state": "Задекларований стан",
  "Amends snapshot": "Виправляє знімок",
  "Attach saved evidence": "Додати збережені підтвердні матеріали",
  "preparing": "Підготовка",
  "downloading": "Завантаження",
  "ready": "Готово",
  "rejected": "Відхилено",
  "closed": "Закрито",
  "pending": "Очікує",
  "sending": "Надсилання",
  "accepted": "Прийнято",
  "conflict": "Конфлікт",
  "staged": "Збережено локально",
  "uploading": "Передавання",
  "verified": "Перевірено",
  "attached": "Додано",
  "Captured inputs": "Зафіксовані вхідні дані",
  "Captured route": "Зафіксований маршрут",
  "Planned components": "Заплановані компоненти",
  "No planned components.": "Запланованих компонентів немає.",
  "No file evidence recorded.": "Файли підтвердних матеріалів не зареєстровано.",
  "Evidence files": "Файли підтвердних матеріалів",
  "Actual outputs": "Фактичний випуск продукції",
  "No actual outputs recorded.": "Фактичний випуск продукції не зареєстровано.",
  "Operations and inspections": "Операції та перевірки",
  "Create shared run": "Створити спільний виробничий запуск",
  "Record rework": "Зареєструвати переробку",
  "No operations or inspections recorded.": "Операції та перевірки не зареєстровано.",
  "Actual components and lots": "Фактичні компоненти та партії",
  "Record component or lot": "Зареєструвати компонент або партію",
  "No actual components recorded.": "Фактичні компоненти не зареєстровано.",
  "Job documents": "Документи завдання",
  "Whole job": "Усе завдання",
  "Actual component": "Фактичний компонент",
  "Unserialized output": "Несеріалізована продукція",
  "Not declared": "Не задекларовано",
  "Declare production": "Задекларувати стан виробництва",
  "Declare quality": "Задекларувати стан якості",
  "Amend as-built": "Виправити фактичну конфігурацію",
  "Declaration history": "Історія декларацій",
  "As-built history": "Історія фактичної конфігурації",
  "Snapshot": "Знімок стану",
  "Choose a declaration.": "Виберіть декларацію.",
  "As-built snapshot": "Знімок фактичної конфігурації",
  "Actual output": "Фактичний випуск",
  "No serialized units found.": "Серійних одиниць не знайдено.",
  "Serialized output": "Серіалізована продукція",
  "Clear": "Очистити",
  "Choose a result.": "Виберіть результат.",
  "Inspection name": "Назва перевірки",
  "Use shared run": "Використати спільний запуск",
  "This job is not part of this shared run.": "Це завдання не входить до цього спільного запуску.",
  "Choose another run": "Вибрати інший запуск",
  "Run identifier": "Ідентифікатор запуску",
  "Serialized unit": "Серійна одиниця",
  "Select the actual component or lot.": "Виберіть фактичний компонент або партію.",
  "Serial units": "Серійні одиниці",
  "Allocate serials": "Виділити серійні номери",
  "Import serial labels": "Імпортувати серійні позначення",
  "Void": "Анулювати",
  "Void serial": "Анулювати серійний номер",
  "Reprint label": "Повторно надрукувати етикетку",
  "Enter positive integer serial numbers.": "Введіть серійні номери як додатні цілі числа.",
  "Number of serials": "Кількість серійних номерів",
  "Existing serial numbers": "Наявні серійні номери",
  "Serial label": "Серійна етикетка",
  "Allow pop-ups to print this label.": "Дозвольте спливні вікна, щоб надрукувати цю етикетку.",
  "Print label": "Надрукувати етикетку",
  "Lot {lot} uses draft material revision {revision}.": "Партія {lot} використовує чернетку ревізії матеріалу {revision}.",
  "Consumed quarantined stock: {lot}.": "Витрачено запаси на карантині: {lot}.",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "Недостатньо запасів: {lot} у {location} ({disposition}); доступно {available}, зареєстрована витрата {outgoing}.",
  "syncing": "Синхронізація",
  "Supply the selected template's values.": "Укажіть значення для вибраного шаблону.",
  "Manual intake contains an unknown column.": "Ручне введення містить невідомий стовпець.",
  "A manual value is missing or too long.": "Значення ручного введення відсутнє або задовге.",
  "Supply CSV text.": "Укажіть текст CSV.",
  "Supply CSV text of at most 1 MiB.": "Укажіть текст CSV розміром до 1 МіБ.",
  "CSV text cannot contain null characters.": "Текст CSV не може містити нульові символи.",
  "CSV exceeds the 1 MiB UTF-8 limit.": "CSV перевищує межу 1 МіБ у UTF-8.",
  "CSV must contain valid UTF-8 text.": "CSV має містити коректний текст UTF-8.",
  "The CSV header is missing.": "Заголовок CSV відсутній.",
  "Every header must be unique.": "Кожен заголовок має бути унікальним.",
  "The template requires this header, even when its values are optional.": "Шаблон вимагає цей заголовок, навіть якщо значення необов’язкові.",
  "This column is not in the selected template.": "Цього стовпця немає у вибраному шаблоні.",
  "CSV contains more than 500 data rows.": "CSV містить понад 500 рядків даних.",
  "This row must have exactly the number of fields in the header.": "Кількість полів цього рядка має точно відповідати заголовку.",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "Некоректні лапки CSV або поле перевищує межу 16 000 символів. Виправте джерело та створіть новий перегляд.",
  "A source reference may occur only once in a preview.": "Посилання на джерело може траплятися лише один раз у перегляді.",
  "Supply at least one data row.": "Укажіть принаймні один рядок даних.",
  "This preview uses an older intake contract. Create a new preview.": "Цей перегляд використовує застарілі правила імпорту. Створіть новий перегляд.",
  "The selected row does not match this immutable preview.": "Вибраний рядок не відповідає цьому незмінному перегляду.",
  "Correct the CSV errors and create a new preview before applying this row.": "Виправте помилки CSV та створіть новий перегляд перед застосуванням рядка.",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "Цей вихідний рядок уже застосовано з іншими даними або іншим реєстратором. Його не можна перезаписати.",
  "This row no longer meets the intake contract. Create a new preview.": "Цей рядок більше не відповідає правилам імпорту. Створіть новий перегляд.",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "Пов’язані дані змінилися після перегляду. Перевірте актуальні дані та створіть новий перегляд; цей рядок не було автоматично узгоджено.",
  "No exact company reference matches this value.": "Цьому значенню не відповідає жодне точне посилання в компанії.",
  "This reference is ambiguous; select an exact source reference.": "Це посилання неоднозначне; виберіть точне посилання на джерело.",
  "This material identifier already exists; intake does not overwrite definitions.": "Цей ідентифікатор матеріалу вже існує; імпорт не перезаписує визначення.",
  "This lot identifier already exists; intake does not overwrite lots.": "Цей ідентифікатор партії вже існує; імпорт не перезаписує партії.",
  "Use the exact material revision unit.": "Використовуйте точну одиницю ревізії матеріалу.",
  "Use the exact authored lot unit; stock is not converted.": "Використовуйте точну задану одиницю партії; запаси не перераховуються.",
  "The job must produce the exact selected part.": "Завдання має виготовляти саме вибрану деталь.",
  "This serial is already allocated or imported and cannot be reused.": "Цей серійний номер уже виділено або імпортовано; повторне використання неможливе.",
  "A serialized output is exactly one ea.": "Серіалізована продукція має кількість рівно 1 ea.",
  "A part job cannot declare a material lot output.": "Завдання для деталі не може декларувати випуск партії матеріалу.",
  "The operation must exist in the job's captured route.": "Операція має існувати в зафіксованому маршруті завдання.",
  "Select one actual output by its exact source reference.": "Виберіть один фактичний випуск за точним посиланням на джерело.",
  "Use at most {maximum} characters.": "Використовуйте не більше {maximum} символів.",
  "A value is required.": "Потрібне значення.",
  "Use a positive, unpadded integer.": "Використовуйте додатне ціле число без початкових нулів.",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "Укажіть додатну десяткову кількість без розділювачів груп, не більше шести дробових і дванадцяти цілих цифр.",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "Укажіть фактичну часову позначку UTC, наприклад 2026-09-07T12:30:00Z.",
  "Choose Accepted or Quarantined.": "Виберіть Accepted або Quarantined.",
  "Choose Completed, Failed, Skipped or InProgress.": "Виберіть Completed, Failed, Skipped або InProgress.",
  "Choose Passed, Failed or Inconclusive.": "Виберіть Passed, Failed або Inconclusive.",
  "An imported serial requires its complete part PIN.": "Імпортований серійний номер потребує повного PIN деталі.",
  "Choose Production or Quality.": "Виберіть Production або Quality.",
  "Choose a declaration value belonging to this kind.": "Виберіть значення декларації, що відповідає цьому виду.",
  "This intake preview was not found for this recorder and company.": "Цей перегляд імпорту не знайдено для цього реєстратора та компанії.",
  "This preview row was not found.": "Цей рядок перегляду не знайдено.",
  "Choose a published intake template.": "Виберіть опублікований шаблон імпорту.",
  "Use an actual UTC timestamp.": "Укажіть фактичну часову позначку UTC.",
  "This material identifier already exists.": "Цей ідентифікатор матеріалу вже існує.",
  "Released or used definitions stay unchanged. Create a new revision.": "Випущені або використані визначення залишаються незмінними. Створіть нову ревізію.",
  "This material revision is already released.": "Цю ревізію матеріалу вже випущено.",
  "Use the exact material revision unit; stock is not converted.": "Використовуйте точну одиницю ревізії матеріалу; запаси не перераховуються.",
  "This lot identifier already exists.": "Цей ідентифікатор партії вже існує.",
  "This lot changed. Reload its balances before recording stock.": "Ця партія змінилася. Завантажте актуальні залишки перед реєстрацією запасів.",
  "Use the lot's exact authored unit; stock is not converted.": "Використовуйте точну задану одиницю партії; запаси не перераховуються.",
  "Reverse the original movement before recording its replacement.": "Сторнуйте початковий рух запасів перед реєстрацією заміни.",
  "This movement already has a replacement.": "Цей рух запасів уже має заміну.",
  "This movement has already been corrected.": "Цей рух запасів уже виправлено.",
  "Use an exact location without surrounding whitespace.": "Укажіть точне місце зберігання без пробілів на початку та в кінці.",
  "Split and merge require the same exact material revision.": "Розділення й об’єднання потребують тієї самої конкретної ревізії матеріалу.",
  "Split and merge preserve disposition.": "Розділення й об’єднання зберігають стан придатності.",
  "Split and merge quantities must match exactly.": "Кількості при розділенні й об’єднанні мають точно збігатися.",
  "This split or merge would create a cycle in the retained lot genealogy.": "Це розділення або об’єднання створило б цикл у збереженому походженні партій.",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "Кількість має бути додатною, не більше шести десяткових знаків і дванадцяти цілих цифр.",
  "Offline storage is unavailable. No local save was confirmed.": "Автономне сховище недоступне. Локальне збереження не підтверджено.",
  "Offline recording requires browser storage locking.": "Для автономної реєстрації потрібне блокування сховища браузера.",
  "Offline storage could not save the change. Keep the original work and retry.": "Автономне сховище не зберегло зміну. Збережіть початкову роботу та повторіть спробу.",
  "Offline session not found.": "Автономний сеанс не знайдено.",
  "Resolve the saved change shown above before synchronizing offline work.": "Узгодьте показану вище збережену зміну перед синхронізацією автономної роботи.",
  "This offline session is not the active recorder.": "Цей автономний сеанс не є активним сеансом реєстрації.",
  "Offline file storage is unavailable in this browser.": "Сховище автономних файлів недоступне в цьому браузері.",
  "Offline storage capacity cannot be checked.": "Неможливо перевірити місткість автономного сховища.",
  "Not enough browser storage for the selected offline files.": "У сховищі браузера недостатньо місця для вибраних автономних файлів.",
  "Streaming downloads are unavailable.": "Потокове завантаження недоступне.",
  "Choose one job and distinct offline files.": "Виберіть одне завдання та різні автономні файли.",
  "Choose distinct material lots and component units for offline use.": "Виберіть різні партії матеріалів та одиниці компонентів для автономної роботи.",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "Відновіть з’єднання, узгодьте активну автономну роботу та явно закрийте її перед зміною реєстратора чи завдання.",
  "Finish preparation or closing before resolving offline work.": "Завершіть підготовку або закриття перед узгодженням автономної роботи.",
  "Choose an unresolved conflicting or rejected command.": "Виберіть невирішену конфліктну або відхилену дію.",
  "This offline session is not ready for new commands.": "Цей автономний сеанс не готовий до нових дій.",
  "Choose distinct evidence staged in this offline session.": "Виберіть різні підтвердні матеріали, збережені в цьому автономному сеансі.",
  "Only operation attempts and inspections support staged evidence.": "Лише спроби виконання операцій і перевірки підтримують збережені локально підтвердні матеріали.",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "Передайте та перевірте пов’язані автономні підтвердні матеріали перед синхронізацією цієї дії.",
  "Select at most 1000 evidence files.": "Виберіть не більше 1000 файлів підтвердних матеріалів.",
  "Finish preparation or closing before synchronizing.": "Завершіть підготовку або закриття перед синхронізацією.",
  "Finish preparation before synchronizing.": "Завершіть підготовку перед синхронізацією.",
  "The offline command response did not confirm acceptance.": "Відповідь на автономну дію не підтвердила її прийняття.",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "Передайте й додайте збережені автономні підтвердні матеріали перед закриттям. Локальні матеріали зберігаються.",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "Узгодьте всю роботу, що очікує, конфліктує або відхилена, перед закриттям цього автономного сеансу.",
  "The server session was closed elsewhere. Review the retained local work.": "Серверний сеанс закрито в іншому місці. Перегляньте збережену локальну роботу.",
  "The server did not confirm closing this offline session.": "Сервер не підтвердив закриття цього автономного сеансу.",
  "This file has not been downloaded and verified for offline use.": "Цей файл не завантажено й не перевірено для автономної роботи.",
  "This offline session is not ready for new evidence.": "Цей автономний сеанс не готовий до нових підтвердних матеріалів.",
  "Choose a nonempty evidence file and filename.": "Виберіть непорожній файл підтвердних матеріалів і вкажіть назву.",
  "This evidence has not been staged for offline use.": "Ці підтвердні матеріали не збережено для автономної роботи.",
  "Finish closing before updating evidence.": "Завершіть закриття перед оновленням підтвердних матеріалів.",
  "Offline evidence changed. Read its current state before continuing.": "Автономні підтвердні матеріали змінилися. Перегляньте їхній актуальний стан перед продовженням.",
  "Resume the original evidence upload.": "Продовжте початкове передавання підтвердних матеріалів.",
  "The verified server file does not match the staged evidence.": "Перевірений серверний файл не відповідає збереженим локально підтвердним матеріалам.",
  "This offline session belongs to another recorder.": "Цей автономний сеанс належить іншому реєстратору.",
  "This offline session is closed. Its pending work cannot be submitted here.": "Цей автономний сеанс закрито. Його роботу, що очікує, не можна подати тут.",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "Цей ідентифікатор дії вже пов’язано з іншою роботою. Збережіть початкову дію та зареєструйте виправлення окремо.",
  "Use a serial reserved for this job before the session was prepared.": "Використовуйте серійний номер, зарезервований для цього завдання до підготовки сеансу.",
  "This component unit changed. Keep the recorded work and review the conflict.": "Ця одиниця компонента змінилася. Збережіть зареєстровану роботу та перевірте конфлікт.",
  "This component revision changed. Keep the recorded work and review the conflict.": "Ця ревізія компонента змінилася. Збережіть зареєстровану роботу та перевірте конфлікт.",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "Ця партія матеріалу змінилася. Збережіть зареєстровану роботу та перевірте конфлікт запасів перед поданням виправлення.",
  "This material revision changed. Keep the recorded work and review the conflict.": "Ця ревізія матеріалу змінилася. Збережіть зареєстровану роботу та перевірте конфлікт.",
  "The command payload does not match its record type. Keep the original pending work for review.": "Дані дії не відповідають типу запису. Збережіть початкову роботу, що очікує, для перевірки.",
  "Not started": "Не розпочато",
  "In progress": "У процесі",
  "Captured part revision was a draft.": "Зафіксована ревізія деталі була чернеткою.",
  "Captured configuration was a draft.": "Зафіксована конфігурація була чернеткою.",
  "A captured component revision was a draft.": "Одна із зафіксованих ревізій компонентів була чернеткою.",
  "Captured material revision was a draft.": "Зафіксована ревізія матеріалу була чернеткою.",
  "Captured route revision was a draft.": "Зафіксована ревізія маршруту була чернеткою.",
  "A captured document revision was a draft.": "Одна із зафіксованих ревізій документів була чернеткою.",
  "No route was captured.": "Маршрут не було зафіксовано.",
  "An operation has no completed attempt.": "Для однієї з операцій немає завершеної спроби.",
  "An expected inspection was not recorded.": "Передбачену перевірку не зареєстровано.",
  "The history includes failed operations.": "Історія містить невдалі операції.",
  "The history includes skipped operations.": "Історія містить пропущені операції.",
  "The history includes failed inspections.": "Історія містить непройдені перевірки.",
  "The history includes inconclusive inspections.": "Історія містить перевірки без однозначного висновку.",
  "No inspection evidence was recorded.": "Підтвердні матеріали перевірок не зареєстровано.",
  "Planned components have no recorded actuals.": "Для запланованих компонентів не зареєстровано фактичне використання.",
  "A planned component quantity differs from the recorded actuals.": "Запланована кількість компонента відрізняється від зареєстрованої фактичної.",
  "Quality has not been declared.": "Стан якості не задекларовано.",
  "Production has not been declared.": "Стан виробництва не задекларовано.",
  "Some actual components are recorded for the whole job, not an individual output.": "Деякі фактичні компоненти зареєстровано для всього завдання, а не окремого випуску.",
  "Some completed operations have no file evidence.": "Деякі завершені операції не мають файлових підтверджень.",
  "An operation was recorded out of order.": "Операцію зареєстровано з порушенням послідовності.",
  "The serial label is void.": "Серійне позначення анульовано.",
  "Additional evidence warning recorded.": "Зареєстровано додаткове попередження щодо підтвердних матеріалів.",
  "Document": "Документ",
  "Applies to output": "Стосується випуску",
  "Earlier lot": "Попередня партія",
  "From lot": "Із партії",
  "Captured component evidence": "Зафіксовані підтвердні матеріали компонента",
  "Actual genealogy": "Фактичне походження",
  "Related operation": "Пов’язана операція",
  "Shared runs": "Спільні виробничі запуски",
  "Add job to shared run": "Додати завдання до спільного запуску",
  "Actual component type": "Тип фактичного компонента",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "Прийнята дія реєстрації має підтвердити додавання цих підтвердних матеріалів.",
  "Choose a downloaded material lot or component serial.": "Виберіть завантажену партію матеріалу або серійну одиницю компонента.",
  "Choose a supported evidence update.": "Виберіть підтримуване оновлення підтвердних матеріалів.",
  "Choose a supported offline command and an object payload.": "Виберіть підтримувану автономну дію та дані у вигляді об’єкта.",
  "Choose the output receiving this component.": "Виберіть випуск продукції, до якого входить цей компонент.",
  "Evidence file references must be a list of server file IDs.": "Посилання на файли підтвердних матеріалів мають бути списком ідентифікаторів серверних файлів.",
  "Evidence upload failed.": "Не вдалося передати підтвердні матеріали.",
  "Offline payloads must contain only JSON values.": "Дані автономних дій мають містити лише значення JSON.",
  "Online registry": "Реєстр у мережі",
  "Provide a corrected command payload object.": "Надайте виправлені дані дії у вигляді об’єкта.",
  "Provide the evidence upload error.": "Укажіть помилку передавання підтвердних матеріалів.",
  "Reconnect to verify recorder access before synchronizing.": "Відновіть з’єднання, щоб перевірити доступ реєстратора перед синхронізацією.",
  "The offline bundle is missing selected material lots or component units.": "В автономному наборі немає вибраних партій матеріалів або одиниць компонентів.",
  "The offline file SHA-256 does not match its manifest.": "SHA-256 автономного файлу не відповідає його опису.",
  "The offline file URL does not match its session.": "URL автономного файлу не відповідає його сеансу.",
  "The offline file length does not match its manifest.": "Розмір автономного файлу не відповідає його опису.",
  "The offline file manifest is invalid.": "Опис автономного файлу некоректний.",
  "The offline manifest does not match the selected files.": "Автономний опис не відповідає вибраним файлам.",
  "The offline session does not belong to this recorder and job.": "Автономний сеанс не належить цьому реєстратору та завданню.",
  "The prepared offline bundle does not match this recorder and job.": "Підготовлений автономний набір не відповідає цьому реєстратору та завданню.",
  "The retained correction chain is incomplete.": "Збережений ланцюжок виправлень неповний.",
  "The retained correction chain is invalid.": "Збережений ланцюжок виправлень некоректний.",
  "The selected job changed. Open its download choices again.": "Вибране завдання змінилося. Відкрийте його параметри завантаження знову.",
  "The selected offline file could not be downloaded.": "Не вдалося завантажити вибраний автономний файл.",
  "The staged evidence failed SHA-256 verification.": "Локально підготовлені підтвердні матеріали не пройшли перевірку SHA-256.",
  "The stored offline evidence failed SHA-256 verification.": "Збережені автономні підтвердні матеріали не пройшли перевірку SHA-256.",
  "The stored offline file failed SHA-256 verification.": "Збережений автономний файл не пройшов перевірку SHA-256.",
  "This offline session is closed.": "Цей автономний сеанс закрито.",
  "This offline session is closed. Pending work is retained.": "Цей автономний сеанс закрито. Роботу, що очікує, збережено.",
  "Agent": "Агент",
  "Agents": "Агенти",
  "Member": "Учасник",
  "Agent name": "Назва агента",
  "Agent reference": "Посилання на агента",
  "Connected applications": "Підключені застосунки",
  "Connection address": "Адреса підключення",
  "MCP endpoint": "Адреса MCP",
  "New agent": "Новий агент",
  "Create agent": "Створити агента",
  "Manage": "Керувати",
  "Review transfer": "Переглянути передачу",
  "Management transfer awaiting your response": "Передача керування очікує вашої відповіді",
  "Management transfer pending": "Очікується передача керування",
  "No connected applications.": "Немає підключених застосунків.",
  "No agents yet.": "Агентів ще немає.",
  "Last used {date}": "Востаннє використано {date}",
  "Disconnect": "Відключити",
  "Disconnect {name}?": "Відключити {name}?",
  "This application will lose access through this connection.": "Цей застосунок втратить доступ через це підключення.",
  "Manage {name}?": "Керувати {name}?",
  "Accept management": "Прийняти керування",
  "Decline transfer": "Відхилити передачу",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "Прийняття керування відкликає чинні облікові дані. Створіть нові перед наступним запуском агента.",
  "Disabled": "Вимкнено",
  "Enable agent": "Увімкнути агента",
  "Disable agent": "Вимкнути агента",
  "Enable {name}?": "Увімкнути {name}?",
  "Disable {name}?": "Вимкнути {name}?",
  "Rename": "Перейменувати",
  "Rename agent": "Перейменувати агента",
  "Transfer management": "Передати керування",
  "Cancel transfer": "Скасувати передачу",
  "Request transfer": "Запросити передачу",
  "New manager’s Google account email": "Електронна адреса Google нового керівника",
  "Share agent reference": "Поділитися посиланням на агента",
  "Company access": "Доступ до компаній",
  "No company access. A company owner can add this agent in Members.": "Немає доступу до компаній. Власник компанії може додати агента в розділі «Учасники».",
  "Credentials": "Облікові дані",
  "New credential": "Нові облікові дані",
  "Create credential": "Створити облікові дані",
  "Credential name": "Назва облікових даних",
  "No credentials yet.": "Облікових даних ще немає.",
  "Rotate secret": "Замінити секрет",
  "Rotate {name}?": "Замінити секрет {name}?",
  "Revoke {name}?": "Відкликати {name}?",
  "Create new credentials after enabling this agent.": "Після ввімкнення агента створіть нові облікові дані.",
  "This revokes its credentials and stops access in every company.": "Це відкликає облікові дані та припиняє доступ до всіх компаній.",
  "Existing access tokens issued with this credential will stop working.": "Чинні токени доступу, видані з цими обліковими даними, перестануть діяти.",
  "Connection credentials": "Облікові дані підключення",
  "Client ID": "Ідентифікатор клієнта",
  "Client secret": "Секрет клієнта",
  "The secret is shown only once. Save it in your agent’s credential storage.": "Секрет показується лише один раз. Збережіть його у сховищі облікових даних агента.",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "Облікові дані створено, але секрет неможливо показати знову. Замініть секрет.",
  "Copy {value}": "Копіювати {value}",
  "Copy was unavailable. Select the value and copy it manually.": "Копіювання недоступне. Виділіть значення та скопіюйте його вручну.",
  "Add agent": "Додати агента",
  "Choose a valid agent reference.": "Укажіть дійсне посилання на агента.",
  "Managed by {name}": "Керує {name}",
  "Connect application": "Підключити застосунок",
  "Allow connection": "Дозволити підключення",
  "Redirect address": "Адреса перенаправлення",
  "This application can use your current company roles. Access follows changes to your memberships.": "Цей застосунок може діяти відповідно до ваших поточних ролей у компаніях. Доступ змінюється разом із вашим членством.",
  "Agent created": "Агента створено",
  "Agent updated": "Агента оновлено",
  "Agent disabled": "Агента вимкнено",
  "Credential created": "Облікові дані створено",
  "Credential rotated": "Облікові дані замінено",
  "Credential revoked": "Облікові дані відкликано",
  "Transfer requested": "Передачу запрошено",
  "Transfer cancelled": "Передачу скасовано",
  "Transfer accepted": "Передачу прийнято",
  "Active agent not found.": "Активного агента не знайдено.",
  "Agent not found.": "Агента не знайдено.",
  "Managed agent not found.": "Керованого агента не знайдено.",
  "Credential not found.": "Облікові дані не знайдено.",
  "Connection not found.": "Підключення не знайдено.",
  "Transfer not found.": "Передачу не знайдено.",
  "This transfer has expired.": "Термін передачі минув.",
  "Choose another manager.": "Виберіть іншого керівника.",
  "The new manager must sign in to the registry first.": "Новий керівник має спочатку ввійти до реєстру.",
  "A human account manages agent credentials.": "Обліковими даними агента керує людина.",
  "Enable the agent before creating credentials.": "Увімкніть агента перед створенням облікових даних.",
  "Create a new credential after revocation.": "Після відкликання створіть нові облікові дані.",
  "This agent is already a member.": "Цей агент уже є учасником.",
  "Another owner must accept membership before disabling the last owner.": "Інший власник має прийняти запрошення перед вимкненням останнього власника.",
  "Application not found.": "Застосунок не знайдено.",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "Спільні деталі",
  "Common": "Спільна",
  "Add part to {value0}": "Додати деталь до {value0}",
  "Assembly actions": "Дії збірки",
  "Create symmetry": "Створити симетрію",
  "Variant created.": "Варіант створено.",
  "Symmetry family updated.": "Сімейство симетрії оновлено.",
  "Document categories": "Категорії документів",
  "Document category": "Категорія документа",
  "Add category": "Додати категорію",
  "Edit category": "Редагувати категорію",
  "Edit category {name}": "Редагувати категорію {name}",
  "Category added.": "Категорію додано.",
  "Category saved.": "Категорію збережено.",
  "Category name": "Назва категорії",
  "Category code": "Код категорії",
  "App default": "Стандартна",
  "Archived": "Архівна",
  "Show archived categories": "Показати архівні категорії",
  "No categories available.": "Немає доступних категорій.",
  "Reload": "Оновити",
  "Only company owners and editors can manage document categories.": "Лише власники та редактори компанії можуть керувати категоріями документів.",
  "Existing categories share these codes: {codes}. Their records remain separate.": "Наявні категорії мають однакові коди: {codes}. Їхні записи залишаються окремими.",
  "Upload document": "Завантажити документ",
  "Apply to selected": "Застосувати до вибраних",
  "Back to files": "Назад до файлів",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "Сховище браузера недоступне. Не закривайте це вікно, щоб зберегти зміни.",
  "Category for {name}": "Категорія для {name}",
  "Check the saved upload change before continuing.": "Перевірте збережену зміну завантаження, перш ніж продовжити.",
  "Choose a matching document": "Виберіть відповідний документ",
  "Choose which document should receive this revision.": "Виберіть документ, до якого слід додати цю ревізію.",
  "Create a separate document": "Створити окремий документ",
  "Detected from": "Визначено за",
  "Drag and drop files here": "Перетягніть файли сюди",
  "Edit selected files": "Редагувати вибрані файли",
  "Edit {count} selected files": "Редагувати вибрані файли: {count}",
  "File details and applicability": "Відомості про файл і застосовність",
  "File preview": "Попередній перегляд файлу",
  "File size": "Розмір файлу",
  "Filename": "Ім’я файлу",
  "Keep current": "Залишити поточні",
  "Matching document for {name}": "Відповідний документ для {name}",
  "New document": "Новий документ",
  "New revision of {identifier}": "Нова ревізія {identifier}",
  "Next file": "Наступний файл",
  "Not specified": "Не вказано",
  "Preview unavailable for this file format.": "Попередній перегляд цього формату файлу недоступний.",
  "Preview {name}": "Попередній перегляд {name}",
  "Previous file": "Попередній файл",
  "Reading file details…": "Зчитування відомостей про файли…",
  "Recover saved upload": "Відновити збережене завантаження",
  "Select a file to preview.": "Виберіть файл для попереднього перегляду.",
  "Select all files": "Вибрати всі файли",
  "Select files": "Вибрати файли",
  "Select files to upload.": "Виберіть файли для завантаження.",
  "Select the original file to preview or resume.": "Виберіть початковий файл для перегляду або продовження завантаження.",
  "Select the original file to resume.": "Виберіть початковий файл, щоб продовжити завантаження.",
  "Select {name}": "Вибрати {name}",
  "Title for {name}": "Назва для {name}",
  "Title pattern": "Шаблон назви",
  "Uploading {name}": "Завантаження {name}",
  "Use {name} for the current title and {n} for a sequence number.": "Використовуйте {name} для поточної назви, а {n} — для порядкового номера.",
  "{count} files": "Файлів: {count}",
  "{count} selected": "Вибрано: {count}",
  "{done} of {total} uploaded": "Завантажено {done} із {total}",
  "Add files": "Додати файли",
  "Retry unfinished uploads": "Повторити незавершені завантаження",
  "Drawing": "Креслення",
  "Assembly drawing": "Складальне креслення",
  "Production drawing": "Виробниче креслення",
  "Bill of materials": "Специфікація матеріалів",
  "Work instruction": "Робоча інструкція",
  "Schematic": "Принципова схема",
  "Wiring diagram": "Схема з’єднань",
  "Layout": "Компонування",
  "3D model": "3D-модель",
  "Test procedure": "Методика випробувань",
  "Test report": "Протокол випробувань",
  "Inspection plan": "План контролю",
  "Inspection report": "Звіт про контроль",
  "Certificate": "Сертифікат",
  "Material datasheet": "Технічний паспорт матеріалу",
  "Calculation": "Розрахунок",
  "Requirements": "Вимоги",
  "Design report": "Проєктний звіт",
  "Assembly instruction": "Інструкція зі складання",
  "Manufacturing process": "Технологічний процес",
  "Quality plan": "План якості",
  "Change notice": "Повідомлення про зміну",
  "Manual": "Посібник",
  "Upload": "Завантажити",
  "Ready": "Готово",
  "Needs attention": "Потребує уваги",
  "Retained": "Збережена",
  "manual": "Змінено вручну",
  "filename": "Ім’я файлу",
  "embedded metadata": "Вбудовані метадані",
  "filename fallback": "Ім’я файлу; загальна категорія",
  "Embedded metadata": "Вбудовані метадані",
  "Embedded title": "Вбудована назва",
  "File selection key": "Ключ вибору файлу",
  "Media type": "Тип вмісту",
  "Document category added": "Категорію документів додано",
  "Document category archived": "Категорію документів архівовано",
  "Document category updated": "Категорію документів оновлено",
  "Document upload batch created": "Створено пакет завантаження документів",
  "Document draft retained": "Чернетку документа збережено",
  "Document upload saved": "Завантажений документ збережено",
  "Add a Company or Project category.": "Додайте категорію компанії або проєкту.",
  "Choose a category available in this document context.": "Виберіть категорію, доступну для цього документа.",
  "Choose a project only for a Project category.": "Вибирайте проєкт лише для категорії проєкту.",
  "Choose the project that owns this document context.": "Виберіть проєкт, до якого належить цей документ.",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "Цей код категорії вже існує тут або в успадкованих категоріях. Виберіть інший код.",
  "This category is archived. Choose an available category.": "Цю категорію архівовано. Виберіть доступну категорію.",
  "This editable category was not found in this company.": "У цій компанії не знайдено такої категорії для редагування.",
  "Use an uppercase alphanumeric category code starting with a letter.": "Використовуйте код категорії з великих латинських літер і цифр, що починається з літери.",
  "A saved document file cannot be removed from its upload batch.": "Збережений файл документа не можна видалити з пакета завантаження.",
  "A selected file key is already in this batch.": "Ключ вибраного файлу вже є в цьому пакеті.",
  "Choose a document category.": "Виберіть категорію документа.",
  "Choose a row in this upload batch.": "Виберіть рядок у цьому пакеті завантаження.",
  "Choose an available document category.": "Виберіть доступну категорію документа.",
  "Choose between 1 and 1000 files.": "Виберіть від 1 до 1000 файлів.",
  "Choose distinct upload rows to edit.": "Виберіть різні рядки завантаження для редагування.",
  "Choose either an existing document or a new document.": "Виберіть наявний або новий документ.",
  "Resume this batch with the recorder who started it.": "Продовжте цей пакет під обліковим записом, який його розпочав.",
  "Several documents match this file. Choose the intended document or create a separate document.": "Цьому файлу відповідає кілька документів. Виберіть потрібний або створіть окремий документ.",
  "The selected document no longer matches this owner, category and title. Review the row again.": "Вибраний документ більше не відповідає цьому власнику, категорії та назві. Перевірте рядок ще раз.",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "Цей документ має незавершене завантаження. Завершіть або скасуйте його, перш ніж повторити цей рядок.",
  "This upload batch was cancelled.": "Цей пакет завантаження скасовано.",
  "This upload row is already saved or cancelled.": "Цей рядок завантаження вже збережено або скасовано.",
  "Upload and verify this file before saving the document.": "Завантажте й перевірте цей файл перед збереженням документа.",
  "Select the original file for this upload row.": "Виберіть початковий файл для цього рядка завантаження.",
  "This row already has a different upload. Cancel that upload before replacing it.": "Цей рядок уже має інше завантаження. Скасуйте його перед заміною.",
  "Preview will be available after upload.": "Попередній перегляд стане доступним після завантаження.",
  "existing document": "Наявний документ",
  "file extension": "Розширення файлу",
  "More": "Ще",
  "Edit quantity for {value0}": "Змінити кількість для {value0}",
  "This structure cannot contain itself.": "Структура не може містити саму себе."
}
